import AnimateHeading from "../features/AnimateHeading";
import AnimatedSvg from "../features/AnimatedSvg";
import CaseStudyExperience from "../features/CaseStudyExperience";
import ContactUs from "../features/ContactUs";
import Footer from "../features/Footer";
import Header from "../features/Header";
import Masthead from "../features/Masthead";
import MastheadCaseStudy from "../features/MastheadCaseStudy";
import OurApproach from "../features/OurApproach";
import OurApproachV2 from "../features/OurApproachV2";
import OurJourney from "../features/OurJourney";
import OurLeaders from "../features/OurLeaders";
import OurWorks from "../features/OurWorks";
import OurWorksListing from "../features/OurWorksListing";
import SliderCaseStudy from "../features/SliderCaseStudy";
import Testimonials from "../features/Testimonials";

interface DYNAMIC_CLASSES_PARAMS {
    className: string;
    item: HTMLElement;
    callback: string | string[];
    opt?: unknown;
}

const CLASSES = {
    AnimatedSvg,
    Header,
    Footer,
    Masthead,
    OurWorks,
    OurWorksListing,
    OurLeaders,
    AnimateHeading,
    OurJourney,
    ContactUs,
    Testimonials,
    OurApproach,
    OurApproachV2,
    MastheadCaseStudy,
    SliderCaseStudy,
    CaseStudyExperience,
};

class DynamicClass {
    constructor({ className, item, callback, opt = null }: DYNAMIC_CLASSES_PARAMS) {
        return new CLASSES[className]({
            item,
            callback,
            opt,
        });
    }
}

export default DynamicClass;
